import axios from "axios";
import { unoStore } from "@simulanisindia/ui";


const apiClient = axios.create({
    headers: {
        "Content-Type": "application/json"
    }
});

const successResponseInterceptor = (response) => {
    return response?.data?.data;
};

const errorResponseInterceptor = (error) => {
    throw error
};


const requestInterceptor = (req) => {
    const state = unoStore.getState();
    const userData = state.user;
    req.headers.Authorization = `Bearer ${userData.token}`;
    return req;
}

apiClient.interceptors.request.use(requestInterceptor);
apiClient.interceptors.response.use(successResponseInterceptor, errorResponseInterceptor);

export default apiClient;